import {
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';

export type CheckAppVersionState = {
  appVersion: Maybe<string>;
  openOutdatedAppVersionModal: boolean;
};

const initialState: CheckAppVersionState = {
  appVersion: null,
  openOutdatedAppVersionModal: false,
};

export const checkAppVersionSlice = createSlice({
  name: 'check-app-version',
  initialState,
  reducers: {
    setAppVersion: (state: CheckAppVersionState, action: PayloadAction<string>) => {
      state.appVersion = action.payload;
    },
    setOpenOutdatedAppVersionModal: (state: CheckAppVersionState, action: PayloadAction<boolean>) => {
      state.openOutdatedAppVersionModal = action.payload;
    },
  },
});

export const {
  setAppVersion,
  setOpenOutdatedAppVersionModal
} = checkAppVersionSlice.actions;
export const checkAppVersionReducer = checkAppVersionSlice.reducer;